<div class="accordion" [ngClass]="{'border-collapsed': isCollapsed, 'border-expanded': !isCollapsed}">
    <div class="accordion__header" (click)="onToggleCollapse()">
        <div class="accordion__header-title">
            <div class="accordion__header-title__label">
                <bzg-icon nameIcon="icon-filters"></bzg-icon>
                <h2>{{ 'TRACE.FILTERS' | translate}}</h2>
            </div>
            <svg class="accordion__header-title__icon" [ngClass]="{'rotate-icon': !isCollapsed}">
                <use href="#icon-arrow-down-bold"></use>
            </svg>
        </div>
    </div>
    <div *ngIf="!isCollapsed" class="accordion__content">
        <div class="accordion-separator"></div>
        <div class="accordion__filter">
            <div class="accordion__filter-element">
                <span class="accordion__filter-label">{{'VIEW_DELTA.VIEW_MODE' | translate}}</span>
                <bzg-select [placeholder]="'VIEW_DELTA.VIEW_MODE' | translate" [(value)]="selectedViewMode"
                    (valueChange)="onViewModeChange($event)">
                    <bzg-option [value]="'basic'">{{ 'VIEW_DELTA.BASIC' | translate }}</bzg-option>
                    <bzg-option [value]="'expert'">{{ 'VIEW_DELTA.EXPERT' | translate }}</bzg-option>
                </bzg-select>
            </div>
            <div class="accordion__filter-element">
                <span class="accordion__filter-label">{{'VIEW_DELTA.COMPARISON_TYPE' | translate}}</span>
                <bzg-select [placeholder]="'VIEW_DELTA.COMPARISON_TYPE' | translate" [(value)]="selectedDeltaTypes"
                    (valueChange)="onDeltaTypeChange($event)" [multiple]="true">
                    <bzg-option *ngFor="let dt of sortedComparisonTypes" [value]="dt">{{ ('VIEW_DELTA.COMPARISON_TYPES.' + dt.trim().toUpperCase()) | translate }}</bzg-option>
                </bzg-select>
            </div>
            <div class="accordion__filter-element">
                <span class="accordion__filter-label">{{'VIEW_DELTA.OBJECT_TYPE' | translate}}</span>
                <bzg-select [placeholder]="'VIEW_DELTA.OBJECT_TYPE' | translate" [(value)]="selectedType"
                    (valueChange)="onTypeChange($event)">
                    <bzg-option [value]="null">{{ 'VIEW_DELTA.ALL' | translate }}</bzg-option>
                    <bzg-option *ngFor="let t of sortedObjectTypes" [value]="t" [title]="('OBJECT_TYPES.' + t.trim().toUpperCase()) | translate">
                      {{ ('OBJECT_TYPES.' + t.trim().toUpperCase()) | translate }}
                    </bzg-option>
                </bzg-select>
            </div>
            <div class="accordion__filter-element">
                <bzg-input [(ngModel)]="nameFilter" (ngModelChange)="onSearchChange($event)"
                    placeholder="{{'VIEW_DELTA.NAME' | translate}}" name="nameFilter" id="nameFilter">
                    {{'VIEW_DELTA.NAME' | translate}}
                </bzg-input>
            </div>      
        </div>
        <div class="accordion__filter-btn">
          <div class="accordion__filter-btn-space">
            <bzg-button-secondary  (click)="cleanFilters()">{{'VIEW_DELTA.CLEAN_FILTERS' | translate}}</bzg-button-secondary>
          </div>
        </div>
    </div>
</div>